// src/elements/Brand/generated/brands.types.ts
var NAME_MAP = {
  "abnamro": "abnamro",
  "amex": "amex",
  "bancontactmrcash": "bancontactmrcash",
  "cartebancaire": "cartebancaire",
  "creditcards": "creditcards",
  "dhl": "dhl",
  "fsc-certificate-blank": "fsc-certificate-blank",
  "fsc": "fsc",
  "ideal": "ideal",
  "ing": "ing",
  "kiyoh": "kiyoh",
  "mastercard": "mastercard",
  "paypal": "paypal",
  "postnl": "postnl",
  "printdeal-all-white": "printdeal-all-white",
  "printdeal-logo-mark": "printdeal-logo-mark",
  "printdeal-white": "printdeal-white",
  "printdeal": "printdeal",
  "rabobank": "rabobank",
  "visa": "visa"
};
export { NAME_MAP };